<ui-grid [data]="data$ | async"
         [loading]="loading$ | async">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="main">
            <ng-template>
                <button [matTooltip]="'grid_action_add' | translate"
                        [uiAuthorize]="'Environments.Create'"
                        [uiClickTrack]="'Action: Add Environment'"
                        (click)="openModal()"
                        color="primary"
                        mat-mini-fab
                        data-cy="environment-add"
                        type="button">
                    <mat-icon>add</mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorize]="'Environments.Delete'"
                        [matTooltip]="'environments_action_remove_tooltip' | translate"
                        (click)="removeItems()"
                        mat-icon-button
                        color="warn"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete20px">
                    </mat-icon>
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>
    <ui-grid-column [sortable]="true"
                    [searchable]="true"
                    [primary]="true"
                    [title]="'environments_grid_name' | translate"
                    property="name"
                    sort="asc"
                    width="30%">
    </ui-grid-column>
    <ui-grid-column [searchable]="true"
                    [title]="'environments_grid_description' | translate"
                    property="description"
                    width="50%">
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [matTooltip]="'global_more_actions_tooltip' | translate"
                    [matMenuTriggerFor]="menu"
                    data-cy="grid-action-menu"
                    mat-icon-button
                    type="button">
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button [uiAuthorize]="'Environments.Edit'"
                        [uiClickTrack]="'Action: Grid: Edit'"
                        (click)="openModal(entry)"
                        mat-menu-item
                        data-cy="environment-edit-robot"
                        type="button">
                    <mat-icon svgIcon="uipath:Edit"></mat-icon>
                    {{ 'environments_action_edit_tooltip' | translate }}
                </button>
                <button [uiAuthorizeAll]="['Robots.View','Environments.View']"
                        [uiClickTrack]="'Action: Grid: Manage'"
                        (click)="showEnvironment(entry)"
                        mat-menu-item
                        data-cy="environment-manage-robots"
                        type="button">
                    <mat-icon svgIcon="uipath:ManageEnvironment"></mat-icon>
                    {{ 'environments_action_manage_tooltip' | translate }}
                </button>
                <button [uiAuthorize]="'Environments.Delete'"
                        [uiClickTrack]="'Action: Grid: Remove'"
                        (click)="removeItems([entry])"
                        mat-menu-item
                        color="warn"
                        data-cy="environment-remove"
                        type="button">
                    <mat-icon svgIcon="uipath:Delete"></mat-icon>
                    {{ 'environments_action_remove_tooltip' | translate }}
                </button>
            </mat-menu>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
